import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";

export const GoBackButtonStyled = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  cursor: "pointer",
  "&:hover": {
    opacity: 0.8,
  },

  ".icon-button": {
    padding: "4px",
    color: theme.palette.text?.secondary || "#6B7280",
    "&:hover": {
      backgroundColor: "transparent",
    },
  },

  ".text": {
    fontSize: "14px",
    marginLeft: "8px",
    color: theme.palette.text?.secondary || "#6B7280",
    fontWeight: 400,
  },
}));
